"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGraphSolarHeight = exports.useGraphNonSolarHeight = exports.useScrollToRightOnLoadDailyGraph = exports.useDailyGraphSize = exports.useUsagePeriod = void 0;
var tslib_1 = require("tslib");
var react_1 = require("react");
var useBreakpoint_1 = require("../../hooks/useBreakpoint");
/** Add empty columns to push real columns to the left  */
function useUsagePeriod(usagePeriods, barThickness, containerRef) {
    var isMobile = (0, useBreakpoint_1.useBreakpoint)().isMobile;
    var _a = (0, react_1.useState)(false), viewReady = _a[0], setViewReady = _a[1];
    var usagePeriodsPadding = (0, react_1.useMemo)(function () {
        var _a, _b;
        var minNumCols = 28;
        var padAmt = minNumCols - usagePeriods.length;
        var overflows = containerRef.current
            ? ((_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.scrollWidth) > ((_b = containerRef.current) === null || _b === void 0 ? void 0 : _b.clientWidth)
            : false;
        return overflows || padAmt < 0 || isMobile
            ? usagePeriods
            : tslib_1.__spreadArray(tslib_1.__spreadArray([], usagePeriods, true), Array.from({ length: padAmt }).map(function () { return undefined; }), true);
    }, [usagePeriods, isMobile, containerRef]);
    (0, react_1.useLayoutEffect)(function () {
        var element = containerRef.current;
        if (element) {
            setViewReady(element.clientWidth > 0);
        }
    }, [containerRef, usagePeriods]);
    return {
        viewReady: viewReady,
        usagePeriods: usagePeriodsPadding,
        minChartPxWidth: "".concat(usagePeriods.length * (barThickness * 1.5), "px"),
    };
}
exports.useUsagePeriod = useUsagePeriod;
function useDailyGraphSize(usagePeriods, isSnapshot) {
    var usagePeriodData = (0, react_1.useMemo)(function () { return usagePeriods.map(function (x) { var _a, _b; return (_b = (_a = x === null || x === void 0 ? void 0 : x.usage) === null || _a === void 0 ? void 0 : _a.cost) !== null && _b !== void 0 ? _b : 0; }); }, [usagePeriods]);
    var solarPeriodData = (0, react_1.useMemo)(function () { return usagePeriods.map(function (x) { var _a, _b; return (_b = (_a = x === null || x === void 0 ? void 0 : x.solar) === null || _a === void 0 ? void 0 : _a.cost) !== null && _b !== void 0 ? _b : 0; }); }, [usagePeriods]);
    var maxGraphValue = Math.max.apply(Math, usagePeriodData);
    var maxGraphSolarValue = Math.max.apply(Math, solarPeriodData);
    var maxValue = Math.max(maxGraphValue, maxGraphSolarValue);
    var ceilValue = maxValue < 10 ? 1 : maxValue < 100 ? 10 : 100;
    var maxY = Math.ceil(maxValue / ceilValue) * ceilValue;
    var findYAxisValue = function (highestDataValue) { return (maxY / 2.0 >= highestDataValue ? maxY / 2 : maxY); };
    var graphYAxisValue = findYAxisValue(maxGraphValue);
    var graphSolarYAxisValue = findYAxisValue(maxGraphSolarValue);
    return {
        graphYAxisValue: graphYAxisValue,
        graphSolarYAxisValue: graphSolarYAxisValue,
        graphIsSmall: !isSnapshot && graphYAxisValue < graphSolarYAxisValue,
        graphSolarIsSmall: !isSnapshot && graphSolarYAxisValue < graphYAxisValue,
        graphEqualSize: isSnapshot || graphSolarYAxisValue === graphYAxisValue,
        usagePeriodData: usagePeriodData,
        solarPeriodData: solarPeriodData,
    };
}
exports.useDailyGraphSize = useDailyGraphSize;
function useScrollToRightOnLoadDailyGraph(containerRef, usagePeriods, viewReady) {
    (0, react_1.useLayoutEffect)(function () {
        var _a, _b;
        (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.scrollTo({ left: (_b = containerRef.current) === null || _b === void 0 ? void 0 : _b.scrollWidth });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [usagePeriods, viewReady]);
}
exports.useScrollToRightOnLoadDailyGraph = useScrollToRightOnLoadDailyGraph;
function useGraphNonSolarHeight(opt) {
    if (opt.isSnapshot) {
        return {
            percentage: 100,
            verticalPaddingPx: opt.hasSolar ? 10 : 0,
        };
    }
    if (!opt.hasSolar) {
        return {
            percentage: 100,
            verticalPaddingPx: opt.paddingOffset,
        };
    }
    if (opt.isEqualSized) {
        return {
            percentage: 50,
            verticalPaddingPx: opt.paddingOffset,
        };
    }
    // is small 1:2
    if (opt.isSmall) {
        return {
            percentage: 33,
            verticalPaddingPx: opt.paddingOffset,
        };
    }
    // is large 2:1
    return {
        percentage: 66,
        verticalPaddingPx: opt.paddingOffset,
    };
}
exports.useGraphNonSolarHeight = useGraphNonSolarHeight;
function useGraphSolarHeight(opt) {
    if (opt.isSnapshot) {
        return {
            percentage: 100,
            verticalPaddingPx: 0,
        };
    }
    if (opt.isEqualSized) {
        return {
            percentage: 50,
            verticalPaddingPx: opt.paddingOffset,
        };
    }
    // is small 1:2
    if (opt.isSmall) {
        return {
            percentage: 33,
            verticalPaddingPx: opt.paddingOffset,
        };
    }
    // is large 2:1
    return {
        percentage: 66,
        verticalPaddingPx: opt.paddingOffset,
    };
}
exports.useGraphSolarHeight = useGraphSolarHeight;
//# sourceMappingURL=DailyUsageGraph.hooks.js.map